import { formatInTimezone, formatTimeInTimezone, formatDateInTimezone } from '@kioskgaming/ui';
import type { CashierShift } from '../services/cashierApi';

export function formatShiftWindow(
  shift: Pick<CashierShift, 'scheduledStartAt' | 'scheduledEndAt' | 'shiftDate'>,
  timezone: string,
): string {
  if (shift.scheduledStartAt && shift.scheduledEndAt) {
    return `${formatInTimezone(shift.scheduledStartAt, timezone)} – ${formatTimeInTimezone(shift.scheduledEndAt, timezone)}`;
  }
  if (shift.shiftDate) {
    return formatDateInTimezone(shift.shiftDate, timezone);
  }
  return '—';
}
